import * as React from "react";
const SvgFiRrGlassWhiskeyRocks = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-glass-whiskey-rocks_svg__a)">
      <path
        fill="#062147"
        d="M15.728 10.111a2.096 2.096 0 0 0-2.73-.195A2 2 0 0 0 11 7.999H7c-1.103 0-2 .897-2 2v4c0 1.103.897 2 2 2h3.385l2.388 2.389c.407.407.942.61 1.478.61s1.07-.204 1.478-.611l2.66-2.661c.395-.395.612-.919.612-1.478s-.218-1.083-.612-1.477l-2.66-2.662zM7 10h4v4H6.999zm9.974 4.313-2.66 2.661a.09.09 0 0 1-.127 0l-1.671-1.671c.302-.35.484-.805.484-1.303v-1.287l1.187-1.187a.09.09 0 0 1 .127 0l2.66 2.661zm6.26-12.326A3 3 0 0 0 21.01 1h-18a3 3 0 0 0-2.218.979 3.01 3.01 0 0 0-.77 2.3l1.324 14.186a4.98 4.98 0 0 0 4.979 4.536h11.275c2.58 0 4.72-1.936 4.976-4.502L23.995 4.3a3 3 0 0 0-.76-2.312zm-1.23 2.112-1.42 14.199a2.99 2.99 0 0 1-2.984 2.701H6.324a2.984 2.984 0 0 1-2.986-2.721L2.014 4.092a.99.99 0 0 1 .256-.767.99.99 0 0 1 .739-.327h18a.996.996 0 0 1 .995 1.101"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-glass-whiskey-rocks_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrGlassWhiskeyRocks;
